export default "__VITE_ASSET__D683TmFM__"